export default __webpack_public_path__ + "static/media/cleaning.43ddf404.png";